import React from 'react';
import './custom-button.css';

const CustomButton = ({ 
  children, 
  onClick, 
  variant = 'primary', 
  size = 'medium', 
  disabled = false,
  fullWidth = false,
  icon,
  className = '',
  type = 'button'
}) => {
  const buttonClasses = [
    'custom-button',
    `custom-button--${variant}`,
    `custom-button--${size}`,
    fullWidth ? 'custom-button--full-width' : '',
    disabled ? 'custom-button--disabled' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
    >
      {icon && <span className="custom-button__icon">{icon}</span>}
      <span className="custom-button__text">{children}</span>
    </button>
  );
};

export default CustomButton; 